import Vue from 'vue'
import App from './App'
import '../theme/index.css'
import ElementUI from 'element-ui'
import store from './store/index'
import '../static/font_icon/iconfont.css'
// import 'element-ui/lib/theme-chalk/index.css'
// import 'amfe-flexible';
import router from './router'

Vue.use(require('vue-moment'))
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.filter('cc_format', function (value) {
	value = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
	var matches = value.match(/\d{4,16}/g);
	var match = matches && matches[0] || ''
	var parts = []
	for (var i=0, len=match.length; i<len; i+=4) {
		parts.push(match.substring(i, i+4))
	}
	if (parts.length) {
		return parts.join(' ')
	} else {
		return value
	}
})

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js